import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { MomentModule } from 'ngx-moment';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { ShipmentActivitiesListItemComponent } from '../shipment-activities-list-item/shipment-activities-list-item.component';

@Component({
    standalone: true,
    imports: [RouterLink, MomentModule, TooltipModule, TranslateModule, FontAwesomeModule],
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'li[qwyk-shipment-activities-document]',
    templateUrl: './shipment-activities-document.component.html',
    styleUrls: ['./shipment-activities-document.component.scss'],
})
export class ShipmentActivitiesDocumentComponent extends ShipmentActivitiesListItemComponent {}
